export class VendorStatusInformation {
    status: number;
    statusCode: string;
    displayName: string;
}